module.exports = __webpack_public_path__ + "static/media/icon-credit-card.a19860e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-credit-card.svg
// module id = 884
// module chunks = 0